import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import spaceForceImg  from './assets/spaceforcepic.jpg';
import coastGuardImg from './assets/coastguardpic.jpg';
import armyImg from './assets/armypic.jpg';
import airforceImg from './assets/airforcepic.jpg';
import marineImg from './assets/marinepic.jpg'
import navyImg from './assets/navypic.jpg';
import pentagonImg from './assets/pentagon.jpg';
import usflagImg from './assets/usflag.jpg';
import './styles/Homepage.css';

function Homepage() {
  const navigate = useNavigate();
  const [currentSlide, setCurrentSlide] = useState(0);

  // Military branch images
  const militaryBranches = [
    {
      name: 'U.S. Army',
      image: armyImg // Soldiers marching
    },
    {
      name: 'U.S. Navy',
      image: navyImg // Sailors on warship
    },
    {
      name: 'U.S. Air Force',
      image: airforceImg // Fighter jet
    },
    {
      name: 'U.S. Marine Corps',
      image: marineImg // Marines in action
    },
    {
      name: 'U.S. Coast Guard',
      image: coastGuardImg // Coast Guard rescue
    },
    {
      name: 'U.S. Space Force',
      image: spaceForceImg // Operations center
    }
  ];

  // Auto-rotate slideshow
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % militaryBranches.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [militaryBranches.length]);

  return (
    <div className="homepage">
      <nav className="home-nav">
        <div className="home-nav-inner">
          <div className="home-brand">
            <img
              src="/thinking-solider-pic.png"
              alt="HmmmDD214 Logo"
              className="home-brand-logo"
            />
            <div className="home-brand-text">HmmmDD214?</div>
          </div>
          <button className="home-btn home-btn-gold" onClick={() => navigate('/questionnaire')}>
            Get Started
          </button>
        </div>
      </nav>

      <section className="hero">
        <div className="hero-overlay" style={{ backgroundImage: `url(${usflagImg})` }} />

        <div className="hero-inner padded-less">
          <div className="hero-left">
            <div className="hero-chip">
              Military Transition Program
            </div>

            <h1>
              Thinking about getting your DD Form 214?
            </h1>

            <p className="hero-text">
              If so, make informed decisions about your military and civilian career options with comprehensive financial analysis, lifestyle comparisons, and civilian job matching.
            </p>

            <div className="hero-cta-row">
              <button className="home-btn home-btn-dark" onClick={() => navigate('/questionnaire')}>
                Start Questionnaire
              </button>
            </div>

            <div className="hero-stats">
              <div>
                <div className="stat-number">5-10</div>
                <div className="stat-label">minutes to complete</div>
              </div>
              <div>
                <div className="stat-number">100%</div>
                <div className="stat-label">free to use</div>
              </div>
              <div>
                <div className="stat-number">3</div>
                <div className="stat-label">simple steps</div>
              </div>
            </div>
          </div>

          <div className="hero-slideshow">
            {militaryBranches.map((branch, index) => (
              <div
                key={index}
                className={`slide ${currentSlide === index ? 'active' : ''}`}
              >
                <img 
                  src={branch.image}
                  alt={branch.name}
                  className="slide-image"
                />
                <div className="slide-caption">
                  <div className="slide-title">
                    {branch.name}
                  </div>
                  <div className="slide-subtitle">
                    Works with 
                  </div>
                </div>
              </div>
            ))}
            
            <div className="slide-indicators">
              {}
            </div>
          </div>
        </div>
      </section>

      <section className="home-section home-section-muted full">
        <div className="home-container padded">
          <div className="section-intro">
            <h2>
              Everything You Need to Decide
            </h2>
            <p>
              Comprehensive analysis to help you make the best decision for your future
            </p>
          </div>

          <div className="feature-grid">
            <div className="feature-card">
              <h3>
                Lifestyle Comparison
              </h3>
              <p>
                Find which path better aligns with your preferences and risk tolerance
              </p>
            </div>

            <div className="feature-card">
              <h3>
                Job Matching
              </h3>
              <p>
                Discover civilian careers that align with your military MOS and experience
              </p>
            </div>

            <div className="feature-card">
              <h3>
                Financial Analysis
              </h3>
              <p>
                Compare your military compensation with projected civilian earnings
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section full">
        <div className="home-container padded-less">
          <div className="section-intro">
            <h2>
              How It Works
            </h2>
            <p>
              Three simple steps to get your personalized analysis
            </p>
          </div>

          <div className="steps-grid">
            <div className="step-card">
              <div className="step-number">
                1
              </div>
              <h3>
                Fill Out Questionnaire
              </h3>
              <p>
                Answer questions about your military service, education, and career goals
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">
                2
              </div>
              <h3>
                AI Analysis
              </h3>
              <p>
                Our system analyzes your profile and calculates your financial outlook
              </p>
            </div>

            <div className="step-card">
              <div className="step-number">
                3
              </div>
              <h3>
                Get Your Results
              </h3>
              <p>
                Review detailed comparisons and personalized recommendations
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="home-section home-section-gold home-cta full">
        <div className="home-cta-bg" style={{ backgroundImage: `url(${pentagonImg})` }} />

        <div className="home-cta-inner padded">
          <h2>
            Ready to Plan Your Future?
          </h2>
          <p>
            Take the first step towards making an informed decision about your military career transition
          </p>
          <button className="home-btn home-btn-dark" onClick={() => navigate('/questionnaire')}>
            Start Your Assessment Now
          </button>
          <p className="cta-sub">
            No account required  •  Takes 5 minutes  •  100% free
          </p>
        </div>
      </section>

      <footer className="home-footer">
        <div className="home-container">
          <p>
            HmmmDD214? by © 2026 Techsulting LLC. All rights are reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}

export default Homepage;
